/** @format */

const adescomTableStyle = {
    tableCellRoot: {
        display: 'table-cell',
        fontSize: '11px',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontWeight: '400',
        lineHeight: '20px',
        borderBottom: '1px solid rgba(224, 224, 224, 1)',
        letterSpacing: '0.01071em',
        verticalAlign: 'inherit',
        whiteSpace: 'nowrap',
        padding: '0px 40px 0px 16px',
    },
    tableCellRootBordered: {
        display: 'table-cell',
        fontSize: '11px',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontWeight: '400',
        lineHeight: '20px',
        borderBottom: '1px solid rgba(224, 224, 224, 1)',
        borderRight: '1px solid rgba(224, 224, 224, 1)',
        letterSpacing: '0.01071em',
        verticalAlign: 'inherit',
        whiteSpace: 'nowrap',
        padding: '0px 40px 0px 16px',
    },
    tableCellRootBorderedClientName: {
        display: 'table-cell',
        fontSize: '11px',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontWeight: '400',
        lineHeight: '20px',
        borderBottom: '1px solid rgba(224, 224, 224, 1)',
        borderRight: '1px solid rgba(224, 224, 224, 1)',
        letterSpacing: '0.01071em',
        verticalAlign: 'inherit',
        whiteSpace: 'break-word',
        width: '200px',
        minWidth: '200px',
        maxWidth: '200px',
        padding: '0px 40px 0px 16px',
    },
    tableRowRoot: {
        '&:hover td': {
            backgroundColor: '#ededed!important',
        },
    },
    paperMargin: {
        marginTop: '30px',
    },
    paperContent: {
        width: 'fit-content',
        marginRight: '15px',
    },
    tableRoot: {
        minWidth: '83vw',
    },
    tableStickyHeader: {
        display: 'table-cell',
        fontSize: '11px',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontWeight: '400',
        lineHeight: '20px',
        letterSpacing: '0.01071em',
        verticalAlign: 'inherit',
        whiteSpace: 'nowrap',
        padding: '0px 40px 0px 16px',
        top: '0',
        zIndex: '1',
        backgroundColor: '#fafafa',
        borderBottom: '1px solid rgba(224, 224, 224, 1)',
        borderCollapse: 'separate',
    },
    tableControlStickyHeader: {
        display: 'table-cell',
        fontSize: '11px',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontWeight: '400',
        lineHeight: '20px',
        letterSpacing: '0.01071em',
        verticalAlign: 'inherit',
        whiteSpace: 'nowrap',
        padding: '0px 40px 0px 16px',
        left: '0',
        zIndex: '2',
        position: 'sticky',
        backgroundColor: '#fafafa',
        borderBottom: '1px solid rgba(224, 224, 224, 1)',
        borderRight: '1px solid rgba(224, 224, 224, 1)',
    },
    tableStickyHeaderBordered: {
        display: 'table-cell',
        fontSize: '11px',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontWeight: '400',
        lineHeight: '20px',
        letterSpacing: '0.01071em',
        verticalAlign: 'inherit',
        whiteSpace: 'nowrap',
        padding: '0px 40px 0px 16px',
        top: '0',
        zIndex: '1',
        position: 'sticky',
        backgroundColor: '#fafafa',
        borderBottom: '1px solid rgba(224, 224, 224, 1)',
        borderRight: '1px solid rgba(224, 224, 224, 1)',
        borderCollapse: 'separate',
    },
    tableControlSticky: {
        display: 'table-cell',
        fontSize: '11px',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontWeight: '400',
        lineHeight: '20px',
        borderBottom: '1px solid rgba(224, 224, 224, 1)',
        letterSpacing: '0.01071em',
        verticalAlign: 'inherit',
        whiteSpace: 'nowrap',
        padding: '0px 40px 0px 16px',
        left: '0',
        zIndex: '0',
        position: 'sticky',
        backgroundColor: 'white',
        borderRight: '1px solid rgba(224, 224, 224, 1)',
    },
    tableCellRootHovered: {
        '&:hover': {
            backgroundColor: '#ededed!important',
        },
    },
};

export default adescomTableStyle;
